import { supabase } from '@/services/supabase';

export class BillingOfflineError extends Error {
  constructor() {
    super('You need a connection to upgrade.');
    this.name = 'BillingOfflineError';
  }
}

export const billingService = {
  async startCheckout(interval: 'month' | 'year'): Promise<{ url: string }> {
    if (!navigator.onLine) throw new BillingOfflineError();
    const { data, error } = await supabase.functions.invoke('create-checkout-session', {
      body: { interval },
    });
    if (error) throw error;
    return data as { url: string };
  },

  async openPortal(): Promise<{ url: string }> {
    if (!navigator.onLine) throw new BillingOfflineError();
    const { data, error } = await supabase.functions.invoke('create-portal-session', {});
    if (error) throw error;
    return data as { url: string };
  },
};
